import { ENV } from "@/env";

// Any missing key means push is off in this build; callers fail closed.
export function isFirebaseConfigured(): boolean {
  return Boolean(
    ENV.FIREBASE_API_KEY &&
      ENV.FIREBASE_PROJECT_ID &&
      ENV.FIREBASE_APP_ID &&
      ENV.FIREBASE_MESSAGING_SENDER_ID &&
      ENV.FIREBASE_VAPID_KEY,
  );
}

async function loadMessaging() {
  const [{ getApps, initializeApp }, messagingSdk] = await Promise.all([import("@firebase/app"), import("@firebase/messaging")]);
  const app =
    getApps()[0] ??
    initializeApp({
      apiKey: ENV.FIREBASE_API_KEY,
      projectId: ENV.FIREBASE_PROJECT_ID,
      appId: ENV.FIREBASE_APP_ID,
      messagingSenderId: ENV.FIREBASE_MESSAGING_SENDER_ID,
    });
  return { messagingSdk, messaging: messagingSdk.getMessaging(app) };
}

export async function isFirebasePushSupported(): Promise<boolean> {
  return (await import("@firebase/messaging")).isSupported();
}

export async function fetchPushToken(serviceWorkerRegistration: ServiceWorkerRegistration): Promise<string | null> {
  const { messagingSdk, messaging } = await loadMessaging();
  const token = await messagingSdk.getToken(messaging, { vapidKey: ENV.FIREBASE_VAPID_KEY, serviceWorkerRegistration });
  return token || null;
}

export async function discardPushToken(serviceWorkerRegistration: ServiceWorkerRegistration): Promise<void> {
  const { messagingSdk, messaging } = await loadMessaging();
  // deleteToken needs a current token to exist first.
  await messagingSdk.getToken(messaging, { vapidKey: ENV.FIREBASE_VAPID_KEY, serviceWorkerRegistration });
  await messagingSdk.deleteToken(messaging);
}
